import { render, staticRenderFns } from "./PostList.vue?vue&type=template&id=d9b71816&scoped=true&"
import script from "./PostList.vue?vue&type=script&lang=js&"
export * from "./PostList.vue?vue&type=script&lang=js&"
import style0 from "./PostList.vue?vue&type=style&index=0&id=d9b71816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b71816",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9b71816')) {
      api.createRecord('d9b71816', component.options)
    } else {
      api.reload('d9b71816', component.options)
    }
    module.hot.accept("./PostList.vue?vue&type=template&id=d9b71816&scoped=true&", function () {
      api.rerender('d9b71816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/panel/PostList.vue"
export default component.exports